import React from "react"
import CheckboxField from "components/CheckboxField"
import { FormRow } from "styles/Common"
import InputField from "components/InputField"
import AutoCompleteField from "components/AutoCompleteField"
import { getPublicUniversities } from "services/public"
import SelectField from "components/SelectField"
import { isOZAPI, isUKAPI } from "utils/clientUtils"
import {
  ENTRANCE_SCORE_TYPE_NOT_AUSTRALIA,
  DEFAULT_MAX_CHARACTERS_INPUT_FIELD,
} from "utils/constants"
import { removeStopwords } from "utils/utils"

export class UniversityName extends React.PureComponent {
  render() {
    const {
      university: universityObject,
      disabledForm,
      hasErrors,
      type,
      index,
      showConfiguration,
      organization,
      errors,
      entranceScoreType,
      handleOptionChange,
      postGrad,
    } = this.props
    const {
      university,
      universityNotAttendedInUk,
      universityOther,
      universityCollege,
      country,
    } = universityObject

    const universityValueObject = universityOther
      ? {
          label: universityOther,
          value: universityOther,
          __isNew__: true,
        }
      : university
    const isFAYTDisabled =
      disabledForm || (showConfiguration.showCountryDropdown && country == null)
    const extraText =
      type === "GDL" || type === "LPC" || type === "LPCC"
        ? `If your university does not appear in the dropdown, please add manually.`
        : ""

    const uniNameHeading = this.props.vocational
      ? "Where did you do/are you doing your preparation work?"
      : "Name of university"
    let exampleText
    if (isOZAPI(organization)) {
      exampleText = `the University of New South Wales, type "Wales"`
    } else if (isUKAPI(organization)) {
      exampleText = `the University
        of Leicester, type "Leicester", for the University of
        Cambridge, type "Cambridge" and so on`
    } else {
      exampleText = `Stanford University, type "Stanford", for the University of Cambridge, type "Cambridge" and so on.`
    }

    const hint = this.props.vocational
      ? `Please leave blank if you are currently not doing/have not completed a preparation course`
      : `To find your university from the list, please start
        typing the unique part of your university's name. For
        example, if you attended or are attending ${exampleText}. ${extraText}`

    let outsideText = `I have graduated or will graduate from a university outside of `
    if (isOZAPI(organization)) {
      outsideText += `Australia`
    } else {
      outsideText += `the UK`
    }

    const notAttendedUniInAustralia =
      entranceScoreType === ENTRANCE_SCORE_TYPE_NOT_AUSTRALIA

    return (
      <React.Fragment>
        <FormRow>
          {/* Show only school country is selected*/}
          {showConfiguration.showCountryDropdown && (
            <FormRow>
              <SelectField
                size={"medium"}
                id={`country-${index}`}
                label={"University country"}
                disabled={disabledForm}
                options={this.props.COUNTRY}
                onChange={this.props.handleOptionChange}
                getOptionLabel={({ value }) => value}
                value={country}
                error={errors.missingCollege}
                errorMessage={"Please select"}
                forceErrorDisplay={hasErrors}
              />
            </FormRow>
          )}
          {showConfiguration.showUniversityNameOther && (
            <InputField
              multiline
              id={`universityOther-${index}`}
              onChange={this.props.handleChange}
              heading={uniNameHeading}
              disabled={disabledForm}
              label={"University name"}
              value={universityOther || ""}
              error={errors.missingUniversityOther}
              errorMessage={"Please complete"}
              forceErrorDisplay={hasErrors}
            />
          )}

          {showConfiguration.showUniversityName && (
            <AutoCompleteField
              id={`university-${index}`}
              label={uniNameHeading}
              hint={notAttendedUniInAustralia ? "" : hint}
              placeholder={"University name"}
              loadOptions={inputValue => {
                const inputWithoutStopwords = removeStopwords(inputValue)
                if (inputWithoutStopwords !== "") {
                  return getPublicUniversities(
                    organization,
                    inputValue,
                    country
                  ).then(res => {
                    const result = res.data
                    // if UK undergaduate and checkbox is not ticked
                    if (
                      isUKAPI(organization) &&
                      !postGrad &&
                      !universityNotAttendedInUk
                    ) {
                      return result
                    }
                    result.push({
                      label: inputValue,
                      value: inputValue,
                      __isNew__: true,
                    })

                    return result
                  })
                }
                return Promise.resolve([])
              }}
              isDisabled={isFAYTDisabled}
              onChange={(id, value) => {
                if (
                  value.__isNew__ &&
                  value.value.length < DEFAULT_MAX_CHARACTERS_INPUT_FIELD
                ) {
                  handleOptionChange(id, {})
                  handleOptionChange(`universityOther-${index}`, value.value)
                } else {
                  handleOptionChange(id, value)
                  handleOptionChange(`universityOther-${index}`, null)
                }
              }}
              getOptionLabel={({ value }) => value}
              value={universityValueObject}
              error={errors.missingUniversity}
              errorMessage={"Please complete"}
              forceErrorDisplay={hasErrors}
            />
          )}
        </FormRow>

        {showConfiguration.showGraduatedOutsideCountry && (
          <FormRow>
            <CheckboxField
              id={`universityNotAttendedInUk-${index}`}
              checked={universityNotAttendedInUk}
              disabled={disabledForm}
              onChange={this.props.handleOptionChange}
              label={outsideText}
              value={universityNotAttendedInUk || ""}
              callback={() => {
                this.props.clearStateFields([
                  "university",
                  "universityOther",
                  "universityCollege",
                  "degree",
                  "degreeType",
                  "degreeOther",
                  "degreeClass",
                  "haventCompletedModules",
                  "universityGraduationYear",
                  "universityModules",
                  "universityOverallAverageScore",
                  "universityOverallAverageScoreOther",
                  "universityStartYear",
                ])
              }}
            />
          </FormRow>
        )}

        {showConfiguration.showCollege && (
          <FormRow>
            <SelectField
              size={"medium"}
              id={`universityCollege-${index}`}
              label={"College Attended"}
              options={this.props.COLLEGE_ATTENDED.filter(x => {
                return x.university === university.value
              })}
              disabled={disabledForm}
              onChange={this.props.handleOptionChange}
              getOptionLabel={({ value }) => value}
              value={universityCollege}
              error={errors.missingCollege}
              errorMessage={"Please select"}
              forceErrorDisplay={hasErrors}
            />
          </FormRow>
        )}
      </React.Fragment>
    )
  }
}

UniversityName.defaultProps = {
  university: {},
}

export default UniversityName
